//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.VehicleDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../Features/Features.SelectFeature.js";
import "../no/ScCollector.js";
import "../no/SelectObject.js";
let d=[[[0,"AnalysisType",1,0],[0,"DefinitionMode",1,0],[0,"ModelType",1,0],[0,"PanelObstructionColor",1,0],[0,"PanelObstructionLayer",1,0],[0,"PanelObstructionToggle",1,0],[0,"PercentileUsed",1,0],[0,"SelectCenterPoint",1,"Point",0],[1,"SelectEyellipse",0,"Features.SelectFeature",0],[0,"SelectFaceCurves",1,"ScCollector",0],[0,"SelectFaces",1,"ScCollector",0],[0,"SelectHubCurves",1,"ScCollector",0],[0,"SelectHubOpenings",1,"ScCollector",0],[0,"SelectInnerRim",1,"ScCollector",0],[0,"SelectOuterRim",1,"ScCollector",0],[0,"SelectPlanarCurves",1,"ScCollector",0],[0,"SelectRimSection",1,"ScCollector",0],[0,"SelectSolidHub",1,"ScCollector",0],[0,"SelectSolidRim",1,"ScCollector",0],[0,"SelectSwitchFace",1,"ScCollector",0],[0,"SelectSwitchSolid",1,"ScCollector",0],[0,"SpecifyPlane",1,"Plane",0],[0,"SwitchObstructionColor",1,0],[0,"SwitchObstructionLayer",1,0],[0,"SwitchObstructionToggle",1,0],[0,"SwitchType",1,0],[0,"SwitchVisionColor",1,0],[0,"SwitchVisionLayer",1,0],[0,"SwitchVisionToggle",1,0],[0,"WheelVisionColor",1,0],[0,"WheelVisionLayer",1,0],[0,"WheelVisionToggle",1,0]],[],[]];
SPLM.Features.VehicleDesign.InstrumentPanelVisibilityBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.VehicleDesign.InstrumentPanelVisibilityBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.VehicleDesign.InstrumentPanelVisibilityBuilder.PercentileUsedEnum = Object.freeze({
    "Per95" : "Per95", "Per99" : "Per99"});

SPLM.Features.VehicleDesign.InstrumentPanelVisibilityBuilder.DefinitionModeEnum = Object.freeze({
    "Plane" : "Plane", "Faces" : "Faces"});

SPLM.Features.VehicleDesign.InstrumentPanelVisibilityBuilder.AnalysisTypeEnum = Object.freeze({
    "SteeringWheelObstructionAnalysis" : "SteeringWheelObstructionAnalysis", "SmartSwitchesLeversObstructionAnalysis" : "SmartSwitchesLeversObstructionAnalysis", "CombinedObstructionAnalysis" : "CombinedObstructionAnalysis"});

SPLM.Features.VehicleDesign.InstrumentPanelVisibilityBuilder.ModelTypeEnum = Object.freeze({
    "Curves" : "Curves", "Solids" : "Solids"});

SPLM.Features.VehicleDesign.InstrumentPanelVisibilityBuilder.SwitchTypeEnum = Object.freeze({
    "PlanarCurves" : "PlanarCurves", "CurvesonaFace" : "CurvesonaFace", "Solid" : "Solid"});

export default SPLM;